import { TabKey } from '../types';
import './CategoryTabs.css';

interface CategoryTabsProps {
    active: TabKey;
    onChange: (value: TabKey) => void;
}

const tabs: { key: TabKey; label: string }[] = [
    { key: 'all', label: '全部' },
    { key: 'favorites', label: '收藏' },
    { key: 'dev', label: '开发工具' },
    { key: 'life', label: '生活工具' },
];

const CategoryTabs = ({ active, onChange }: CategoryTabsProps) => {
    return (
        <nav className="category-tabs" aria-label="工具分类">
            {tabs.map((tab) => (
                <button
                    key={tab.key}
                    className={`category-tab ${active === tab.key ? 'active' : ''}`}
                    onClick={() => onChange(tab.key)}
                    aria-pressed={active === tab.key}
                >
                    {tab.label}
                </button>
            ))}
        </nav>
    );
};

export default CategoryTabs;
